/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInventoryCategoryCommand
 */
export interface UpdateInventoryCategoryCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryCategoryCommand
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryCategoryCommand
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryCategoryCommand
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryCategoryCommand
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateInventoryCategoryCommand
     */
    isActive?: boolean;
}

export function UpdateInventoryCategoryCommandFromJSON(json: any): UpdateInventoryCategoryCommand {
    return UpdateInventoryCategoryCommandFromJSONTyped(json, false);
}

export function UpdateInventoryCategoryCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInventoryCategoryCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function UpdateInventoryCategoryCommandToJSON(value?: UpdateInventoryCategoryCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'value': value.value,
        'description': value.description,
        'isActive': value.isActive,
    };
}


